import type { HotelI18n_HotelInfoSettingsPageQuery } from "@/lib/gql/__generated__/graphql";
import { type LangCode } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";
import { FeatureIslandContainer, FeatureIslandHeader } from "@/components/features/_layouts";

import { Button } from "@/components/ui/button/button";

import { useHotelSettingsHotelInfoDefault } from "./hooks/use-hotel-settings-hotel-info-default";
import { HotelSettingsHotelInfoI18nBaseSettingsIsland } from "./island/base";
import { HotelSettingsHotelInfoI18nDetailedInfoSettingsIsland } from "./island/detailed-info";
import { useInitialized } from "../../model/usecase/use-init";

type Props = {
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
	data: HotelI18n_HotelInfoSettingsPageQuery;
};

export const HotelSettingsHotelInfoI18nPresenter = ({ activeLangCode, navigator, data }: Props) => {
	const {
		viewModel,
		hotelSettingsHotelInfoFormModelMethods,
		addressMethods,
		onUpdate: _onUpdate,
	} = useInitialized({
		lang: activeLangCode,
		data,
	});

	const { isDirty, isValid, onUpdate } = useHotelSettingsHotelInfoDefault({
		viewModel,
		onUpdate: _onUpdate,
	});

	useTransitionBlock(isDirty);

	return (
		<FeatureIslandContainer>
			<FeatureIslandHeader
				title="施設情報の編集"
				activeLangCode={activeLangCode}
				navigator={navigator}
				rightChildren={
					<>
						<Button onClick={onUpdate} type="button" size="xl" variant={isValid ? "default" : "disabled"}>
							保存
						</Button>
					</>
				}
			/>

			<HotelSettingsHotelInfoI18nBaseSettingsIsland
				viewModel={viewModel}
				hotelSettingsHotelInfoFormModelMethods={hotelSettingsHotelInfoFormModelMethods}
			/>

			<HotelSettingsHotelInfoI18nDetailedInfoSettingsIsland addressMethods={addressMethods} />
		</FeatureIslandContainer>
	);
};

HotelSettingsHotelInfoI18nPresenter.displayName = "HotelSettingsHotelInfoI18nPresenter";
